import ManageAddQuiz from "./AddQuiz/MangeAddQuiz"
const ManageFcQ = () =>{

    return(
        <>
            Manage
            <ManageAddQuiz/>
        </>
    )
}
export default ManageFcQ